<template>
  <v-navigation-drawer
    v-if="showDrawer"
    v-model="drawer"
    color="secondary"
    class="drawer"
  >
    <v-list nav dense>
      <!-- only one menu for login -->
      <v-list-item v-if="!state.isSignedIn" href="/login" prepend-icon="mdi-login">
        <v-list-item-title>Connexion</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-btn icon @click="drawer = false" class="closeBtn">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-navigation-drawer>

  <v-app-bar app color="primary" elevate-on-scroll class="appBar">
    <v-toolbar-title class="ml-1">
      <router-link to="/" class="logo" style="color: var(--v-theme-on-primary)">
        Saineo
        <img :src="logoUrl" alt="Saineo Logo" class="logo-image" />
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- If user is not signed in, and not in the login page, show the connexion button to route to the login -->
    <template v-if="this.$route.path !== '/login'">
      <v-list class="d-flex align-center my-list navTile">
        <v-list-item href="#/login" :ripple="false">
          <v-list-item-title class="listItemConnexion">Connexion</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>

    <!-- Menu button for mobiles -->
    <v-btn icon v-if="windowWidth <= 945" @click="toggleDrawer">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, reactive } from 'vue';
import logoUrl from '@/assets/logo.png';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useTheme } from 'vuetify';

let auth;
const state = reactive({
  isSignedIn: false,
  userMail: ''
});

export default {
  name: 'NavComp',
  setup() {
    const theme = useTheme();
    const isDarkTheme = ref(false);
    const drawer = ref(false);
    const windowWidth = ref(window.innerWidth);

    const toggleDrawer = () => {
      drawer.value = !drawer.value;
    };

    const updateWindowWidth = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        state.isSignedIn = !!user;
        state.email = user ? user.email : "";
      });

      window.addEventListener('resize', updateWindowWidth);
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        isDarkTheme.value = savedTheme === 'dark';
        theme.global.name.value = isDarkTheme.value ? 'dark' : 'light';
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateWindowWidth);
    });

    return {
      state,
      username: '',
      drawer,
      windowWidth,
      isDarkTheme,
      toggleDrawer,
      theme,
      logoUrl,
    };
  },
  computed: {
    showNavbar() {
      return this.$route.path !== '/login' && this.$route.path !== '/register' && this.$route.path !== '/welcome';
    },
    showDrawer() {
      return this.drawer && this.showNavbar;
    },
  },
};
</script>

<style scoped>

  .listItemConnexion {
    border: 1px solid rgb(var(--v-theme-text));
    border-radius: 5px;
    padding: 0.5em 1em;
  }

  .appBar {
    padding: 0 1vw;
  }

  .logo {
    text-decoration: none;
    color: white;
    font-weight: 600;
    font-size: 1.5em;
    display: inline-flex;
    align-items: center;
    gap: 0.2em;
  }

  .logo-image {
    width: 35px;
    height: 35px;
    object-fit: contain;
    display: inline-block;
  }

  .drawer {
    padding-top: 15vh;
  }

  .closeBtn {
    margin-top: 2em;
  }

  .light-text {
    color: white;
  }

  .dark-text {
    color: #f1f1f1; /* Ou une couleur plus adaptée à ton thème sombre */
  }

  .navTile {
    background-color: transparent;
    font-weight: 500;
  }
</style>
